module.exports = __webpack_public_path__ + "static/media/AvenirNext-DemiBold.9dff2434.woff";